import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Emprunt } from '../entites/emprunt'; 
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { RequeteRetournerEmprunt } from './requetes/requete-retourner-emprunt';

@Injectable({
  providedIn: 'root'
})
export class EmpruntService extends BaseService {
  
  constructor(private http: HttpClient, public router: Router, public messageService: MessageService) {
    super(messageService, router);
  }

  /**
   * Retrieves all emprunts from the API.
   * @returns An Observable of an array of Emprunt objects.
   */
  getEmprunts(): Observable<HttpEvent<Emprunt[]>> {
    return this.http.get<Emprunt[]>(`${environment.apiBaseUrl}emprunt`, {observe: 'events'})
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Retrieves a single emprunt by its ID.
   * @param id The ID of the emprunt to retrieve.
   * @returns An Observable of an Emprunt object.
   */
  getEmpruntById(id: number): Observable<Emprunt> {
    return this.http.get<Emprunt>(`${environment.apiBaseUrl}emprunt/${id}`)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Checks if an emprunt exists for an item.
   * @param itemId The ID of the item to check.
   * @returns An Observable of a boolean value.
   */
  getActiveEmpruntForItem(itemId: number): Observable<Emprunt> {
    return this.http.get<Emprunt>(`${environment.apiBaseUrl}emprunt/item/${itemId}/actif`)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Checks if an emprunt exists for an item.
   * @param itemId The ID of the item to check.
   * @returns An Observable of a boolean value.
   */
  checkEmpruntExistsForItem(itemId: number): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiBaseUrl}emprunt/item/${itemId}/verifierexistance`)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Creates a new emprunt.
   * @param emprunt The Emprunt object to create.
   * @returns An Observable of the created Emprunt object.
   */
  createEmprunt(emprunt: Emprunt): Observable<Emprunt> {
    return this.http.post<Emprunt>(`${environment.apiBaseUrl}emprunt`, emprunt)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Updates an existing emprunt.
   * @param id The ID of the emprunt to update.
   * @param emprunt The updated Emprunt object.
   * @returns An Observable of the updated Emprunt object.
   */
  updateEmprunt(id: number, emprunt: Emprunt): Observable<Emprunt> {
    return this.http.put<Emprunt>(`${environment.apiBaseUrl}emprunt/${id}`, emprunt)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Deletes an emprunt by its ID.
   * @param id The ID of the emprunt to delete.
   * @returns An Observable of type any (or void if your backend returns nothing on success).
   */
  deleteEmprunt(id: number): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}emprunt/${id}`)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  /**
   * Retourne un emprunt.
   * @param id The ID of the emprunt to retourner.
   * @returns An Observable of type void.
   */
  retournerEmprunt(id: number, requete: RequeteRetournerEmprunt): Observable<void> {
    return this.http.post<void>(`${environment.apiBaseUrl}emprunt/${id}/retourner`, requete)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }
}